module.exports = __webpack_public_path__ + "img/emeeting-cover.f66f6062.png";